import request from '@/api/request'

export default {
    /**
     * 获取用户热词列表
     * @returns {Promise}
     */
    getUserHotWords() {
        return request({
            url: '/vocabulary/getUserHotWords',
            method: 'get'
        });
    },
    /**
     * 添加热词
     * @param {Object} params - 参数对象
     * @param {String} params.hotWord - 热词
     * @returns {Promise}
     */
    addHotWord(params) {
        return request({
            url: '/vocabulary/addHotWord',
            method: 'post',
            params: {
                hotWord: params.hotWord
            }
        });
    },
    /**
     * 删除热词
     * @param {Object} params - 参数对象
     * @param {String} params.text - 热词文本
     * @returns {Promise}
     */
    removeHotWord(params) {
        return request({
            url: '/vocabulary/removeHotWord',
            method: 'post',
            params: {
                text: params.text
            }
        });
    }
}
